import { UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TASK_TERM } from "../apiRoutes";

// Define the expected response type (adjust based on your API response)
interface TaskTerm {
  name: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}

interface TaskTermResponse {
  data: {
    records: TaskTerm[];
    pagination: { totalRecords: number }[];
  }[];
}


const fetchTaskTerm = async ({ data }: { data: FieldValues }) => {
  const response = await axiosAuth.get<TaskTermResponse>(TASK_TERM, {
    params: data,
  });
  return response.data;
};

// Query hook
const useTaskTermQuery = (
  data: FieldValues,
  queryParams?:
    | UseQueryOptions<TaskTermResponse, Error, TaskTermResponse, ["taskTerm", FieldValues]>
    | UseMutationOptions<any, Error>
) =>
  useQuery<TaskTermResponse, Error, TaskTermResponse, ["taskTerm", FieldValues]>({
    queryKey: ["taskTerm", data],
    queryFn: () => fetchTaskTerm({ data }),
    ...(queryParams as any), // safely spread because TS can’t know if it's query or mutation
  });

export default useTaskTermQuery;
